import { Injectable } from '@angular/core';

import { StorageService } from 'app/shared/services';

import { defaultMultiUserPreferences, MultiUserPreferences } from '../models';

const multiUserPreferenceKey = 'multi-user-preferences';

@Injectable({ providedIn: 'root' })
export class MultiUserPreferenceService {
    constructor(private storage: StorageService) {}

    getMultiUserPreferencesFromStorageOrDefault(): MultiUserPreferences {
        const preferencesFromStorage =
            this.storage.get<Partial<MultiUserPreferences>>(multiUserPreferenceKey);
        return { ...defaultMultiUserPreferences, ...preferencesFromStorage };
    }

    putMultiUserPreferencesToStorage(preferences: MultiUserPreferences) {
        this.storage.store(multiUserPreferenceKey, preferences);
    }

    clearMultiUserPreferencesFromStorage() {
        this.storage.clear(multiUserPreferenceKey);
    }
}
